import React, { useEffect, useState } from 'react';
import ArrowDown from '../../../assets/icons/arrow-down'
import ArrowUp from '../../../assets/icons/arrow-up'


import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';
import { exportChartGraph, getApplicableSections } from '../../../utils/functionUtils';
import { useCentralStore } from "../../../store/appContext";
import { getCarrierByDomain } from '../../../domain';
import Download from '../../../assets/icons/downloadNew';

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController
);

const SLATrends = ({
  reportName,
  slaReportData,
  theme
}) => {
  const [ { programName, selectedTab }, dispatch ] = useCentralStore()
  // let getBgColor = { 0: '#1ED760', 1: '#685BC7', 2: '#C800A1', 3: '#500878', 4: '#1CD4B0', 5: '#09411D', 6: '#8CBDFA', 7: '#C800A1', 8: '#8A2252', 9: '#878787', 10: '#DC3545', 11: '#1ED760' }
  let getBgColor = theme?.colors?.monthlyTrendsTab?.chartColors


  const [labels, setLabels] = useState(null)
  const [accRejSRData, setAccRejSRData] = useState(null)
  const [deliveryData, setDeliveryData] = useState(null)
  const [deviceRepairData, setDeviceRepairData] = useState(null)
  const [custComplMgmtData, setCustComplMgmtData] = useState(null)
  const [rejectionRateData, setRejectionRateData] = useState(null)
  const [hotlineData, setHotlineData] = useState(null)


  const [srPortal, setSRPortal] = useState(null)
  const [p1Data, setP1Data] = useState(null)
  const [p2Data, setP2Data] = useState(null)
  const [p3Data, setP3Data] = useState(null)
  const [customerOnlineData, setCustomerOnlineData] = useState(null)
  const [customerHotlineData, setCustomerHotlineData] = useState(null)
  const [ { carrierThemeData } ] = useCentralStore()
  useEffect(() => {
    if (slaReportData !== null) {
      let labels = Object.keys(slaReportData) //_slaslaReportData?.Months
      setLabels(labels)

      let dataValues = Object.values(slaReportData)?.flat()

      setAccRejSRData(dataValues?.filter(v => v?.Category === 'Acceptance/ Rejection of Service Requests with communication to Subscriber'))
      let _deliveryData = dataValues?.filter(v => v?.Category === 'Delivery')?.length > 0 ? dataValues?.filter(v => v?.Category === 'Delivery') : dataValues?.filter(v => v?.Category === 'Ontime Delivery')
      setDeliveryData(_deliveryData)
      setDeviceRepairData(dataValues?.filter(v => v?.Category === 'Device Repair'))
      setCustComplMgmtData(dataValues?.filter(v => v?.Category === 'Customer complaints management'))
      setRejectionRateData(dataValues?.filter(v => v?.Category === 'Rejection rate'))
      setHotlineData(dataValues?.filter(v => v?.Category === 'Hotline grade of service - ( Voice Channel )'))

      setSRPortal(dataValues?.filter(v => v?.Category === 'Service Request Portal/ App'))
      setP1Data(dataValues?.filter(v => v?.Category === 'Priority 1 (P1) – Critical Incident'))
      setP2Data(dataValues?.filter(v => v?.Category === 'Priority 2 (P2) – Minor Incident'))
      setP3Data(dataValues?.filter(v => v?.Category === 'Priority 3 (P3) – Improvement'))
      setCustomerOnlineData(dataValues?.filter(v => v?.Category === 'Customer Online Portal Uptime'))
      setCustomerHotlineData(dataValues?.filter(v => v?.Category === 'Customer Hotline Service Uptime'))

    }
  }, [slaReportData])

  const _accRejSRData = {
    Months: accRejSRData?.map(v => v?.Month),
    ['ActualSLA%']: accRejSRData?.map(v => v?.['ActualSLA%']),
    ['ExpectedSLA%']: accRejSRData?.map(v => v?.['ExpectedSLA%']),
  }

  const _deliveryData = {
    Months: deliveryData?.map(v => v?.Month),
    ['ActualSLA%']: deliveryData?.map(v => v?.['ActualSLA%']),
    ['ExpectedSLA%']: deliveryData?.map(v => v?.['ExpectedSLA%']),
  }

  const _deviceRepairData = {
    Months: deviceRepairData?.map(v => v?.Month),
    ['ActualSLA%']: deviceRepairData?.map(v => v?.['ActualSLA%']),
    ['ExpectedSLA%']: deviceRepairData?.map(v => v?.['ExpectedSLA%']),
  }

  const _custComplMgmtData = {
    Months: custComplMgmtData?.map(v => v?.Month),
    ['ActualSLA%']: custComplMgmtData?.map(v => v?.['ActualSLA%']),
    ['ExpectedSLA%']: custComplMgmtData?.map(v => v?.['ExpectedSLA%']),
  }

  const _rejectionRateData = {
    Months: rejectionRateData?.map(v => v?.Month),
    ['ActualSLA%']: rejectionRateData?.map(v => v?.['ActualSLA%']),
    ['ExpectedSLA%']: rejectionRateData?.map(v => v?.['ExpectedSLA%']),
  }

  const _hotlineData = {
    Months: hotlineData?.map(v => v?.Month),
    ['ActualSLA%']: hotlineData?.map(v => v?.['ActualSLA%']),
    ['ExpectedSLA%']: hotlineData?.map(v => v?.['ExpectedSLA%']),
  }

  const _srPortal = {
    Months: srPortal?.map(v => v?.Month),
    ['ActualSLA%']: srPortal?.map(v => v?.['ActualSLA%']),
    ['ExpectedSLA%']: srPortal?.map(v => v?.['ExpectedSLA%']),
  }

  const _p1 = {
    Months: p1Data?.map(v => v?.Month),
    ['ActualSLA%']: p1Data?.map(v => v?.['ActualSLA%']),
    ['ExpectedSLA%']: p1Data?.map(v => v?.['ExpectedSLA%']),
  }

  const _p2 = {
    Months: p2Data?.map(v => v?.Month),
    ['ActualSLA%']: p2Data?.map(v => v?.['ActualSLA%']),
    ['ExpectedSLA%']: p2Data?.map(v => v?.['ExpectedSLA%']),
  }

  const _p3 = {
    Months: p3Data?.map(v => v?.Month),
    ['ActualSLA%']: p3Data?.map(v => v?.['ActualSLA%']),
    ['ExpectedSLA%']: p3Data?.map(v => v?.['ExpectedSLA%']),
  }

  const _customerOnline = {
    Months: customerOnlineData?.map(v => v?.Month),
    ['ActualSLA%']: customerOnlineData?.map(v => v?.['ActualSLA%']),
    ['ExpectedSLA%']: customerOnlineData?.map(v => v?.['ExpectedSLA%']),
  }

  const _customerHotline = {
    Months: customerHotlineData?.map(v => v?.Month),
    ['ActualSLA%']: customerHotlineData?.map(v => v?.['ActualSLA%']),
    ['ExpectedSLA%']: customerHotlineData?.map(v => v?.['ExpectedSLA%']),
  }

  const accRejSRChart = {
    labels: _accRejSRData?.Months,
    datasets: [
      {
        type: 'line',
        label: 'ExpectedSLA%',
        borderColor: getBgColor[0],
        backgroundColor: getBgColor[0],
        borderWidth: 4,
        fill: false,
        data: _accRejSRData['ExpectedSLA%']
      },
      {
        type: 'bar',
        label: 'ActualSLA%',
        backgroundColor: 'black',
        data: _accRejSRData['ActualSLA%'],
        borderColor: 'white',
        borderWidth: 2,
      }
    ],
  }

  const deliveryChart = {
    labels: _deliveryData?.Months,
    datasets: [
      {
        type: 'line',
        label: 'ExpectedSLA%',
        borderColor: getBgColor[0],
        backgroundColor: getBgColor[0],
        borderWidth: 4,
        fill: false,
        data: _deliveryData['ExpectedSLA%'],
      },
      {
        type: 'bar',
        label: 'ActualSLA%',
        backgroundColor: 'black',
        data: _deliveryData['ActualSLA%'],
        borderColor: 'white',
        borderWidth: 2,
      }
    ],
  }

  const deviceRepairChart = {
    labels: _deviceRepairData?.Months,
    datasets: [
      {
        type: 'line',
        label: 'ExpectedSLA%',
        borderColor: getBgColor[0],
        backgroundColor: getBgColor[0],
        borderWidth: 2,
        fill: false,
        data: _deviceRepairData['ExpectedSLA%'],
      },
      {
        type: 'bar',
        label: 'ActualSLA%',
        backgroundColor: 'black',
        data: _deviceRepairData['ActualSLA%'],
        borderColor: 'white',
        borderWidth: 2,
      }
    ],
  }

  const custComplMgmtChart = {
    labels: _custComplMgmtData?.Months,
    datasets: [
      {
        type: 'line',
        label: 'ExpectedSLA%',
        borderColor: getBgColor[0],
        backgroundColor: getBgColor[0],
        borderWidth: 4,
        fill: false,
        data: _custComplMgmtData['ExpectedSLA%'],
      },
      {
        type: 'bar',
        label: 'ActualSLA%',
        backgroundColor: 'black',
        data: _custComplMgmtData['ActualSLA%'],
        borderColor: 'white',
        borderWidth: 2,
      }
    ],
  }

  const rejectionRateChart = {
    labels: _rejectionRateData?.Months,
    datasets: [
      {
        type: 'line',
        label: 'ExpectedSLA%',
        borderColor: getBgColor[0],
        backgroundColor: getBgColor[0],
        borderWidth: 4,
        fill: false,
        data: _rejectionRateData['ExpectedSLA%'],
      },
      {
        type: 'bar',
        label: 'ActualSLA%',
        backgroundColor: 'black',
        data: _rejectionRateData['ActualSLA%'],
        borderColor: 'white',
        borderWidth: 2,
      }
    ],
  }

  const hotlineChart = {
    labels: _hotlineData?.Months,
    datasets: [
      {
        type: 'line',
        label: 'ExpectedSLA%',
        borderColor: getBgColor[0],
        backgroundColor: getBgColor[0],
        borderWidth: 2,
        fill: false,
        data: _hotlineData['ExpectedSLA%'],
      },
      {
        type: 'bar',
        label: 'ActualSLA%',
        backgroundColor: 'black',//getBgColor[0],
        data: _hotlineData['ActualSLA%'],
        borderColor: 'white',
        borderWidth: 2,
      }
    ],
  }

  const _srPortalChart = {
    labels: _srPortal?.Months,
    datasets: [
      {
        type: 'line',
        label: 'ExpectedSLA%',
        borderColor: getBgColor[0],
        backgroundColor: getBgColor[0],
        borderWidth: 4,
        fill: false,
        data: _srPortal['ExpectedSLA%'],
      },
      {
        type: 'bar',
        label: 'ActualSLA%',
        backgroundColor: 'black',
        data: _srPortal['ActualSLA%'],
        borderColor: 'white',
        borderWidth: 2,
      }
    ],
  }

  const _p1Chart = {
    labels: _p1?.Months,
    datasets: [
      {
        type: 'line',
        label: 'ExpectedSLA%',
        borderColor: getBgColor[0],
        backgroundColor: getBgColor[0],
        borderWidth: 4,
        fill: false,
        data: _p1['ExpectedSLA%'],
      },
      {
        type: 'bar',
        label: 'ActualSLA%',
        backgroundColor: 'black',
        data: _p1['ActualSLA%'],
        borderColor: 'white',
        borderWidth: 2,
      }
    ],
  }

  const _p2Chart = {
    labels: _p2?.Months,
    datasets: [
      {
        type: 'line',
        label: 'ExpectedSLA%',
        borderColor: getBgColor[0],
        backgroundColor: getBgColor[0],
        borderWidth: 4,
        fill: false,
        data: _p2['ExpectedSLA%'],
      },
      {
        type: 'bar',
        label: 'ActualSLA%',
        backgroundColor: 'black',
        data: _p2['ActualSLA%'],
        borderColor: 'white',
        borderWidth: 2,
      }
    ],
  }

  const _p3Chart = {
    labels: _p3?.Months,
    datasets: [
      {
        type: 'line',
        label: 'ExpectedSLA%',
        borderColor: getBgColor[0],
        backgroundColor: getBgColor[0],
        borderWidth: 4,
        fill: false,
        data: _p3['ExpectedSLA%'],
      },
      {
        type: 'bar',
        label: 'ActualSLA%',
        backgroundColor: 'black',
        data: _p3['ActualSLA%'],
        borderColor: 'white',
        borderWidth: 2,
      }
    ],
  }

  const _customerOnlineChart = {
    labels: _customerOnline?.Months,
    datasets: [
      {
        type: 'line',
        label: 'ExpectedSLA%',
        borderColor: getBgColor[0],
        backgroundColor: getBgColor[0],
        borderWidth: 2,
        fill: false,
        data: _customerOnline['ExpectedSLA%'],
      },
      {
        type: 'bar',
        label: 'ActualSLA%',
        backgroundColor: 'black',
        data: _customerOnline['ActualSLA%'],
        borderColor: 'white',
        borderWidth: 2,
      }
    ],
  }

  const _customerHotlineChart = {
    labels: _customerHotline?.Months,
    datasets: [
      {
        type: 'line',
        label: 'ExpectedSLA%',
        borderColor: getBgColor[0],
        backgroundColor: getBgColor[0],
        borderWidth: 2,
        fill: false,
        data: _customerHotline['ExpectedSLA%'],
      },
      {
        type: 'bar',
        label: 'ActualSLA%',
        backgroundColor: 'black',
        data: _customerHotline['ActualSLA%'],
        borderColor: 'white',
        borderWidth: 2,
      }
    ],
  }

  const accRejSROptions = {
    layout: {
      // padding: 20
    },
    plugins: {
      // beforeInit: (chart, options) => {
      //   chart.legend.afterFit = () => {
      //     if (chart.legend.margins) {
      //       // Put some padding around the legend/labels
      //       chart.legend.options.labels.padding = 220;
      //       // Because you added 20px of padding around the whole legend,
      //       // you will need to increase the height of the chart to fit it
      //       chart.height += 240;
      //     }
      //   };
      // },
      legend: {
        // position: "top",
        // align: 'end',
        labels: {
          usePointStyle: false,
          // padding: 20
        },
      },
      title: {
        display: true,
        text: 'Acceptance/ Rejection of SR',
        // align: 'start',
        // font: {
        //   size: 20,
        // },
        // padding: 10
      },
      datalabels: {
        formatter: function (value, context) {
          return value > 0 ? value + '%' : null
        },
        align: "bottom",
        labels: {
          usePointStyle: false,
          // align: "top",
          // anchor: "end",
          font: {
            color: getBgColor[0],
            size: 14,
            weight: 900
          }
        },
      },
      // dataset: {
      //   padding: 10
      // }
    },
    responsive: true,
    scales: {
      x: {
        // stacked: true,
        grid: {
          display:false
        }
      },
      y: {
        // stacked: true,
        grid: {
          display:false
        }
      },
    },
    barThickness: 40

  }


  return (
    <div className='w-full'>
      {/* <div className="flex flex-end justify-end cursor-pointer"
          onClick={(e) => exportChartGraph(e, (programName + selectedTab).replace(/\s+/g, ''), programName.replace(/\s+/g, ''))}
        >
          <Download className="" fill={'black'} />
          <div className={`text-black text=[14px] font-bold ml-2`}>
            Export Chart
          </div>
      </div> */}
      <div className={`w-full`}>
        {reportName === 'Customer Service SLA Report' ?
          <>
            <div className={`flex flex-col justify-center items-center rounded-md w-full ${(programName).replace(/\s+/g, '')}`}>
              <div className='flex flex-wrap gap-3'>
                {getApplicableSections(carrierThemeData?.applicableSections, 'CustSLAAcceptRejectionSR') &&
                  <div className='w-[49%] p-3 border border-[#D9D9D9] rounded-lg mt-4'>
                    {/* style={{ borderRight: '1px solid gray', borderBottom: '1px solid gray' }} > */}
                    <Chart options={accRejSROptions} type='bar' data={accRejSRChart} />
                  </div>
                }
                <div className='w-[49%] p-3 border border-[#D9D9D9] rounded-lg mt-4'> 
                  {/* style={{ borderBottom: '1px solid gray' }}> */}
                  <Chart options={{
                    plugins: {
                      // legend: {
                      //   align: 'end'
                      // },
                      datalabels: {
                        formatter: function (value, context) {
                          return value > 0 ? value + '%' : null
                        },
                        align: "bottom",
                        labels: {
                          usePointStyle: false,
                          font: {
                            weight: 700,
                            color: getBgColor[0],
                            size: 12,
                          }
                        },
                      }, 
                      title: { 
                        display: true, 
                        text: getCarrierByDomain()?.toLowerCase() === 'celcom' ? 'Ontime Delivery' : 'Delivery', 
                        // font: {
                        //   size: 20,
                        // },
                        // align: 'start'
                      },
                    }, responsive: true,
                    barThickness: 40,
                    scales: {
                      x: {
                          grid: {
                              display:false
                          }
                      },
                      y: {
                          grid: {
                              display:false
                          }
                      },
                    }
                  }}
                    type='bar'
                    data={deliveryChart} />
                </div>
                <div className='w-[49%] p-3 border border-[#D9D9D9] rounded-lg mt-4'>
                  {/* style={{ borderRight: '1px solid gray' }}> */}
                  <Chart options={{
                    plugins: {
                      // legend:{
                      //   align: 'end'
                      // },
                      datalabels: {
                        formatter: function (value, context) {
                          return value > 0 ? value + '%' : null
                        },
                        align: "bottom",
                        labels: {
                          usePointStyle: false,
                          // fontWeight: 'bold',
                          font: {
                            weight: 700,
                            color: getBgColor[0],
                            size: 12,
                          }
                        },
                      },
                      title: { display: true, text: 'Customer complaints management', 
                      //   align: 'start', font: {
                      //   size: 20,
                      // }, 
                    },
                    },
                    responsive: true,
                    barThickness: 40,
                    scales: {
                      x: {
                          grid: {
                              display:false
                          }
                      },
                      y: {
                          grid: {
                              display:false
                          }
                      },
                    }
                  }}
                    type='bar'
                    data={custComplMgmtChart} />
                </div>
                {getApplicableSections(carrierThemeData?.applicableSections, 'CustSLARejectionRate') &&
                <div className='w-[49%] p-3 border border-[#D9D9D9] rounded-lg mt-4'>
                  <Chart options={{
                    plugins: {
                      // legend: {
                      //   align: 'end'
                      // },
                      datalabels: {
                        formatter: function (value, context) {
                          return value > 0 ? value + '%' : null
                        },
                        align: "bottom",
                        labels: {
                          usePointStyle: false,
                          fontWeight: 'bold',
                          font: {
                            weight: 700,
                            color: getBgColor[0],
                            size: 12,
                          }
                        },
                      },
                      title: { display: true, text: 'Rejection rate', 
                      //   align: 'start', font: {
                      //   size: 20,
                      // },
                    },
                    },
                    responsive: true,
                    barThickness: 40,
                    scales: {
                      x: {
                          grid: {
                              display:false
                          }
                      },
                      y: {
                          grid: {
                              display:false
                          }
                      },
                    }
                  }}
                    type='bar'
                    data={rejectionRateChart} />
                </div>
                }
                {getApplicableSections(carrierThemeData?.applicableSections, 'CustSLADeviceRepair') &&
                  <div className='w-[49%] p-3'>
                    {/* style={{ borderBottom: '1px solid gray' }}> */}
                    <Chart options={{
                      plugins: {
                        datalabels: {
                          formatter: function (value, context) {
                            return value > 0 ? value + '%' : null
                          },
                          align: "bottom",
                          labels: {
                            usePointStyle: false,
                            font: {
                              weight: 700,
                              color: 'black',
                              size: 12,
                            }
                          },
                        },
                        title: { display: true, text: 'Device Repair', },
                      },
                      responsive: true,
                      barThickness: 40,
                      scales: {
                        x: {
                            grid: {
                                display:false
                            }
                        },
                        y: {
                            grid: {
                                display:false
                            }
                        },
                      }
                    }}
                      type='bar'
                      data={deviceRepairChart}
                    />
                  </div>
                }
                {getApplicableSections(carrierThemeData?.applicableSections, 'Hotlinegradeofservice') &&
                  <div className='w-[49%] p-3 border border-[#D9D9D9] rounded-lg mt-4'>
                    <Chart options={{
                      plugins: {
                        // legend:{
                        //   align: 'end'
                        // },
                        datalabels: {
                          formatter: function (value, context) {
                            return value > 0 ? value + '%' : null
                          },
                          align: "bottom",
                          labels: {
                            usePointStyle: false,
                            font: {
                              weight: 700,
                              color: getBgColor[0],
                              size: 12,
                            }
                          },
                        },
                        title: { display: true, text: 'Hotline grade of service - ( Voice Channel )', 
                        //   align: 'start', font: {
                        //   size: 20,
                        // }
                      },
                      },
                      responsive: true,
                      scales: {
                        x: {
                            grid: {
                                display:false
                            }
                        },
                        y: {
                            grid: {
                                display:false
                            }
                        },
                      }
                    }}
                      type='bar'
                      data={hotlineChart} />
                  </div>
                }
              </div>
            </div>
          </>
          :
          <>
            <div className={`flex flex-wrap gap-3 ${(programName).replace(/\s+/g, '')}`}>
            {getApplicableSections(carrierThemeData?.applicableSections, 'TechSLASRPortalApp') &&
              <div className='w-[49%] p-3 border border-[#D9D9D9] rounded-lg mt-4'>
                {/* style={{ borderRight: '1px solid gray', borderBottom: '1px solid gray' }} > */}
                <Chart options={{
                  plugins: {
                    // legend: {
                    //   align: 'end'
                    // },
                    datalabels: {
                      formatter: function (value, context) {
                        return value > 0 ? value + '%' : null
                      },
                      align: "bottom",
                      labels: {
                        usePointStyle: false,
                        font: {
                          weight: 700,
                          color: getBgColor[0],
                          size: 12,
                        }
                      },
                    }, title: { display: true, text: 'Service Request Portal/ App', 
                      // align: 'start', font: { size: 20 } 
                    },
                  }, responsive: true,
                  barThickness: 40,
                  scales: {
                    x: {
                        grid: {
                            display:false
                        }
                    },
                    y: {
                        grid: {
                            display:false
                        }
                    },
                  }
                }}
                  type='bar'
                  data={_srPortalChart} />
              </div>
              }
              {getApplicableSections(carrierThemeData?.applicableSections, 'TechSLAP1') &&
              <div className='w-[49%] p-3 border border-[#D9D9D9] rounded-lg mt-4'>
                {/* style={{ borderBottom: '1px solid gray' }}> */}
                <Chart options={{
                  plugins: {
                    // legend: {
                    //   align: 'end'
                    // },
                    datalabels: {
                      formatter: function (value, context) {
                        return value > 0 ? value + '%' : null
                      },
                      align: "bottom",
                      labels: {
                        usePointStyle: false,
                        font: {
                          weight: 700,
                          color: getBgColor[0],
                          size: 12,
                        }
                      },
                    },
                    title: { display: true, text: 'Priority 1 (P1) - Critical Incident', 
                      // align: 'start', font: { size: 20 }
                    },
                  }, responsive: true,
                  barThickness: 40,
                  scales: {
                    x: {
                        grid: {
                            display:false
                        }
                    },
                    y: {
                        grid: {
                            display:false
                        }
                    },
                  }
                }}
                  type='bar'
                  data={_p1Chart} />
              </div>
              }
              {getApplicableSections(carrierThemeData?.applicableSections, 'TechSLAP2') &&
              <div className='w-[49%] p-3 border border-[#D9D9D9] rounded-lg mt-4'>
                {/* style={{ borderRight: '1px solid gray' }}> */}
                <Chart options={{
                  plugins: {
                    // legend: {
                    //   align: 'end'
                    // },
                    datalabels: {
                      formatter: function (value, context) {
                        return value > 0 ? value + '%' : null
                      },
                      align: "bottom",
                      labels: {
                        usePointStyle: false,
                        font: {
                          weight: 700,
                          color: getBgColor[0],
                          size: 12,
                        }
                      },
                    }, title: { display: true, text: 'Priority 2 (P2) - Minor Incident', 
                      // align: 'start', font: { size: 20 } 
                    },
                  }, responsive: true,
                  barThickness: 40,
                  scales: {
                    x: {
                        grid: {
                            display:false
                        }
                    },
                    y: {
                        grid: {
                            display:false
                        }
                    },
                  }
                }}
                  type='bar'
                  data={_p2Chart} />
              </div>
              }
              {getApplicableSections(carrierThemeData?.applicableSections, 'TechSLAP3') &&
              <div className='w-[49%] p-3 border border-[#D9D9D9] rounded-lg mt-4'>
                <Chart options={{
                  plugins: {
                    // legend: {
                    //   align: 'end'
                    // },
                    datalabels: {
                      formatter: function (value, context) {
                        return value > 0 ? value + '%' : null
                      },
                      align: "bottom",
                      labels: {
                        usePointStyle: false,
                        font: {
                          weight: 700,
                          color: getBgColor[0],
                          size: 12,
                        }
                      },
                    }, title: { display: true, text: 'Priority 3 (P3) - Improvement', 
                      // align: 'start', font: { size: 20 } 
                    },
                  }, responsive: true,
                  barThickness: 40,
                  scales: {
                    x: {
                        grid: {
                            display:false
                        }
                    },
                    y: {
                        grid: {
                            display:false
                        }
                    },
                  }
                }}
                  type='bar'
                  data={_p3Chart} />
              </div>
              }
              {getApplicableSections(carrierThemeData?.applicableSections, 'customerOnlineChart') &&
                <div className='w-[49%] p-3 border border-[#D9D9D9] rounded-lg'>
                  <Chart options={{
                    plugins: {
                      // legend: {
                      //   align: 'end'
                      // },
                      datalabels: {
                        formatter: function (value, context) {
                          return value > 0 ? value + '%' : null
                        },
                        align: "bottom",
                        labels: {
                          usePointStyle: false,
                          font: {
                            weight: 700,
                            color: getBgColor[0],
                            size: 12,
                          }
                        },
                      }, title: { display: true, text: 'Customer Online Portal Uptime', 
                      //   align: 'start', font: {
                      //   size: 20,
                      // }
                    },
                    }, responsive: true,
                    scales: {
                      x: {
                          grid: {
                              display:false
                          }
                      },
                      y: {
                          grid: {
                              display:false
                          }
                      },
                    }
                  }}
                    type='bar'
                    data={_customerOnlineChart} />
                </div>
              }
              {getApplicableSections(carrierThemeData?.applicableSections, 'customerHotlineChart') &&
                <div className='w-[49%] p-3 border border-[#D9D9D9] rounded-lg'>
                  <Chart options={{
                    plugins: {
                      // legend: {
                      //   align: 'end'
                      // },
                      datalabels: {
                        formatter: function (value, context) {
                          return value > 0 ? value + '%' : null
                        },
                        align: "bottom",
                        labels: {
                          usePointStyle: false,
                          font: {
                            weight: 700,
                            color: getBgColor[0],
                            size: 12,
                          }
                        },
                      }, title: { display: true, text: 'Customer Hotline Service Uptime', 
                      //   align: 'start', font: {
                      //   size: 20,
                      // }
                    },
                    }, responsive: true,
                    scales: {
                      x: {
                          grid: {
                              display:false
                          }
                      },
                      y: {
                          grid: {
                              display:false
                          }
                      },
                    }
                  }}
                    type='bar'
                    data={_customerHotlineChart} />
                </div>
              }
            </div>
          </>
        }
    </div>
      </div>
  )
}

export default SLATrends